import { render, staticRenderFns } from "./chackAddress.vue?vue&type=template&id=4b9d7223&scoped=true&"
import script from "./chackAddress.vue?vue&type=script&lang=js&"
export * from "./chackAddress.vue?vue&type=script&lang=js&"
import style0 from "./chackAddress.vue?vue&type=style&index=0&id=4b9d7223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d7223",
  null
  
)

export default component.exports